import React, {FC} from 'react';
import styled from 'styled-components';

import {
  computeContacts,
  computeIsMainHandle,
} from '../../../../srcCommon/inboxes/contactDetails/contactDetailsHelpers';
import {CardAttributeUpdateAction} from '../../../helpers/models/cardAttributeUpdateHelpers';
import {CardModel} from '../../../models/api/cardModel';
import {VisualContactModel} from '../../../models/api/visualContactModel';
import {ContactDetailsPanelLocationsEnum} from '../../../store/panels/contacts/contactDetailsPanelState';
import {useContactDetailsContext} from '../contactDetailsContext';
import {ContactContainer} from './contactContainer';

/*
 * Types.
 */

interface ContactsSectionProps {
  card: CardModel | undefined;
  contact?: VisualContactModel;
  location?: ContactDetailsPanelLocationsEnum;
  updateCardAttributeAsync: (action: CardAttributeUpdateAction) => Promise<void>;
  updateUnsavedCard: (action: CardAttributeUpdateAction) => void;
}

/*
 * Style.
 */

const StyledContactsSectionDiv = styled.div`
  margin: 10px 0;
  display: flex;
  flex-direction: column;
`;

/*
 * Component.
 */

export const ContactsSection: FC<ContactsSectionProps> = (props) => {
  const {card, contact: visualContact, location, updateCardAttributeAsync, updateUnsavedCard} = props;
  const {panelId} = useContactDetailsContext();
  const contacts = computeContacts(card, visualContact);
  return (
    <StyledContactsSectionDiv>
      {contacts.map((contact) => (
        <ContactContainer
          key={contact.uid}
          card={card}
          contact={contact}
          panelId={panelId}
          selectedVisualContact={visualContact}
          location={location}
          isMainHandle={
            location !== ContactDetailsPanelLocationsEnum.CONTACTS_MANAGER &&
            computeIsMainHandle(contact, visualContact)
          }
          updateCardAttributeAsync={updateCardAttributeAsync}
          updateUnsavedCard={updateUnsavedCard}
        />
      ))}
    </StyledContactsSectionDiv>
  );
};
